/* global jQuery bodymovin Waypoint TimelineLite MktoForms2 Swiper:false */

// Dashboard slider & animation
// https://github.com/airbnb/lottie-web
// animation data is exported from Adobe After Effects

(function () {
	"use strict";

	function loadAnimation(selector, data) {
		return bodymovin.loadAnimation({
			container: document.querySelector(selector),
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path: data
		});
	}

	function setWaypointAndAnimation(elementId, offset, animation) {
		var animationStarted = false;

		new Waypoint({
			element: document.getElementById(elementId),
			offset: offset,
			handler: function(direction) {
				if (direction === "down" && !animationStarted) {
					animation.play();
				}

				animationStarted = true;
			}
		});
	}

	var mySwiper = new Swiper(".dahsboard-slider-container", {
		autoHeight: false,
		navigation: {
			nextEl: ".slider-nav--next",
			prevEl: ".slider-nav--prev",
			disabledClass: "swiper-nav-disabled"
		},
		pagination: {
			el: ".swiper-pagination-dashboard",
			type: 'bullets'
		},
		loop: true,
		autoplay: false
	});

	// animation 1
	var animation0 = loadAnimation('.dahsboard-slide.swiper-slide-duplicate .man-icons-binoculars', '/asset/data/apps/asset-inventory/man-icons-binoculars.json');
	var animation1 = loadAnimation('.man-icons-binoculars', '/asset/data/apps/asset-inventory/man-icons-binoculars.json');
	var animation1Started = false;
	if ( !animation1Started) {
		setWaypointAndAnimation('slider', "60%", animation1);
		animation0.play();
		animation1Started = true;
	}

	// when animation 1 has been downloaded, only then download and run the other animations
	animation1.addEventListener("data_ready", function () {
		var animation2Started = false;
		var animation3Started = false;
		var animation4Started = false;
		var animation5Started = false;
		var animation6Started = false;

		mySwiper.on("slideChange", function () {
			if ( mySwiper.realIndex == 1 && !animation2Started) {
				// animation 2
				var animation2 = loadAnimation('.man-pointing-icons', '/asset/data/apps/asset-inventory/man-pointing-icons.json');
				animation2.play();
				animation2Started = true;
			}
			if ( mySwiper.realIndex == 2 && !animation3Started) {
				// animation 3
				var animation3 = loadAnimation('.graph', '/asset/data/apps/asset-inventory/graph.json');
				animation3.play();
				animation3Started = true;
			}
			if ( mySwiper.realIndex == 3 && !animation4Started) {
				// animation 4
				var animation4 = loadAnimation('.asset-summary', '/asset/data/apps/asset-inventory/asset-summary.json');
				// wait 0.5s before animating
				setTimeout(function(){animation4.play();}, 500);
				animation4Started = true;
			}
			if ( mySwiper.realIndex == 4 && !animation5Started) {
				var animation5 = loadAnimation('.dahsboard-slide:not(.swiper-slide-duplicate) .asset-inventory', '/asset/data/apps/asset-inventory/asset-inventory.json');
				// wait 0.5s before animating
				setTimeout(function(){animation5.play();}, 500);
				animation5Started = true;
			}
			if ( mySwiper.realIndex == 4 && mySwiper.previousIndex == 1 && !animation6Started) {
				var animation6 = loadAnimation('.dahsboard-slide.swiper-slide-duplicate .asset-inventory', '/asset/data/apps/asset-inventory/asset-inventory.json');
				// wait 0.5s before animating
				setTimeout(function(){animation6.play();}, 500);
				animation6Started = true;
			}
		});
	});
}());

/*
 * show form on mobile
 */
(function ($) {

	"use strict";

	$(".js-create-account").on("click", function(){
		$(".q-form").addClass("showForm");
		$(".form .js-create-account").addClass("hidden");
	});

}(jQuery));

(function () {

	"use strict";

	// init news and events carousel
	new Swiper(".resources-slider-container", {
		slidesPerView: "auto",
		navigation: false,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
		},
		centeredSlides: false,
		spaceBetween: 30
	});

}());

/*
 * Testimonial quotes slider
 */
(function () {

	"use strict";

	var quoteSwiper = new Swiper(".testimonial-quotes-slider");

	var customerSwiper = new Swiper(".testimonial-customer-slider", {
		autoHeight: false,
		navigation: {
			nextEl: ".quote-nav--next",
			prevEl: ".quote-nav--prev",
			disabledClass: "quote-nav-disabled"
		},
		pagination: {
			el: '.quote-pagination',
			type: 'bullets',
		}

	});

	quoteSwiper.controller.control = customerSwiper;
	customerSwiper.controller.control = quoteSwiper;

}());

// Centered laptop dashboard animation
(function () {
	var tl = new TimelineLite();
	var ease = window.Power4.easeInOut;
	var animationStarted = false;
	var vmDashboard = document.querySelector("#ai-dashboard-1 .q-laptop");
	vmDashboard.classList.add("q-laptop--will-animate");

	new Waypoint({
		element: document.getElementById('ai-dashboard-1'),
		offset: "45%",
		handler: function(direction) {
			if (direction === "down" && !animationStarted) {
				tl.addLabel("start").fromTo("#ai-dashboard-1 .q-laptop", 0.75, { x: "10%", autoAlpha: 0 }, { x: "0%", autoAlpha: 1, ease: ease});
			}

			animationStarted = true;
		}
	});
}());


/*
 * two-panel Marketo form based on the Qualys account question
 */
(function ($, MktoForms2) {

	"use strict";

	MktoForms2.whenRendered(function (form) {

		var $accountInput, $row, accountVal, $accountRadioList, $form, $panel1, $panel2, $theRest;

		$accountInput = $("input[name=qualysAccount]");
		if ($accountInput.length > 0) {

			$form = form.getFormElem();

			// always unwrap to remove panel1 and panel2 divs so we can re do it
			$(".q-mktoFormSet > *").unwrap();

			// split form elements into two sets to create two panels
			// split on the qualysAccount field
			if ($form.find(".mktoButtonNext").length > 0) {
				$row = $form.find(".mktoButtonNext").closest(".mktoButtonRow");
			} else {
				$row = $form.find("input[name=qualysAccount]").closest(".mktoFormRow");
			}
			$panel1 = $row.prevAll().addBack();
			$panel2 = $row.nextAll();
			$panel1.wrapAll("<div class='q-mktoFormSet panel1'/>");
			$panel2.wrapAll("<div class='q-mktoFormSet panel2'/>");

			// show first panel
			$form.addClass("show-first-panel");

			// get radio list
			$accountRadioList = $accountInput.closest(".mktoRadioList");

			// replace qualysAccount field with clone to remove all event listeners
			$accountRadioList.replaceWith($accountRadioList.get(0).cloneNode(true));

			// hide the qualys account field and all the field before it
			// if it, and all the field before it, are valid
			accountVal = $("input[name=qualysAccount]:checked").val();
			if (accountVal) {

				// the qualys account field is valid, now check the rest
				$theRest = $("input[name=qualysAccount]")
					.closest(".mktoFormRow").prevAll()
					.find("input[type!=hidden]:not(.mktoValid)");
				if ($theRest.length === 0) {

					$form.removeClass("show-first-panel");
					$form.addClass("show-next-panel");

				}

			}

		}

	});

	MktoForms2.whenReady(function (form) {

		var $form, $accountInput, $accountRow, $submitButton;

		// save for later
		$form = form.getFormElem();

		// check for the qualys account input
		$accountInput = $form.find("input[name=qualysAccount]");
		if ($accountInput.length > 0) {

			var documentLang = $("html").attr("lang");
			var nextBtnText = "Next";
			var backBtnText = "Back";
			if( "fr" === documentLang) {
				nextBtnText = "Suivant";
				backBtnText = "Précédent";
			}
			else if( "de" === documentLang ){
				nextBtnText = "Weiter";
				backBtnText = "Zurück";
			}
			// inject next button after the qualys account input
			$accountRow = $accountInput.closest(".mktoFormRow");
			$accountRow.after("<div class=\"mktoButtonRow\"><span class=\"mktoButtonWrap mktoInset\"><button type=\"button\" class=\"mktoButton mktoButtonNext\">"+ nextBtnText +"</button></span></div>");
			$(".mktoButtonNext").on("click", function () {

				var accountVal, $theRest;

				// validate visible fields
				form.validate();

				// check account value
				accountVal = $("input[name=qualysAccount]:checked").val();
				if (accountVal) {

					// check Marketo form value
					if (form.getValues()["qualysAccount"] === accountVal) {

						// hide the qualys account field and all the field before it
						// if it, and all the field before it, are valid
						if (accountVal) {

							// the qualys account field is valid, now check the rest
							$theRest = $("input[name=qualysAccount]")
								.closest(".mktoFormRow").prevAll().find("input[type!=hidden]:not(.mktoValid)");
							if ($theRest.length === 0) {

								$form.removeClass("show-first-panel");
								$form.addClass("show-next-panel");

							}

						}

					} else {
						if (accountVal === "yes") {
							if (window.location.pathname === "/apps/global-assetview/form/") {
								window.location.href = "../confirm-existing/";
							} else {
								window.location.href = "confirm-existing/";
							}
						}

						// set the value via the API which causes the form to render
						form.setValues({ "qualysAccount": accountVal });

					}

				} else {
					// show error message for Qualys Account field
					var $accountInputWrapper = $accountInput.parents(".mktoFieldWrap");
					form.showErrorMessage("This field is required.", $accountInputWrapper);
				}

			});

			// inject back button next to the submit button
			$submitButton = $form.find("button[type=submit]");
			$submitButton.before("<button type=\"button\" class=\"mktoButton mktoButtonBack\">"+ backBtnText +"</button>");
			$(".mktoButtonBack").on("click", function () {

				$form.addClass("show-first-panel");
				$form.removeClass("show-next-panel");

			});

		}

		form.onSubmit(function (form) {

			var $form, $theRest;

			$form = form.getFormElem();

			// show panel1 if there are any invalid fields there
			$theRest = $("input[name=qualysAccount]").closest(".mktoFormRow")
				.prevAll().find("input[type!=hidden]:not(.mktoValid)");
			if ($theRest.length > 0) {

				$form.addClass("show-first-panel");
				$form.removeClass("show-next-panel");

			}

		});

	});

}(jQuery, MktoForms2));